import { render, staticRenderFns } from "./ExerciseSection.vue?vue&type=template&id=2848683f&scoped=true"
import script from "./ExerciseSection.vue?vue&type=script&lang=js"
export * from "./ExerciseSection.vue?vue&type=script&lang=js"
import style0 from "./ExerciseSection.vue?vue&type=style&index=0&id=2848683f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2848683f",
  null
  
)

export default component.exports